import { DELETE, GET, PATCH, POST } from "../config/axios.config";
import { normalizeAddress, normalizeAddresses } from "./normalizers";
import { toBdPhone } from "./auth.api";

/**
 * v2 orders are placed against a *saved* address (`addressId`), not an inline
 * one — so checkout needs a real address book. This module backs it.
 */

export const listAddresses = async () => {
  const res = await GET("/addresses");
  return normalizeAddresses(res?.data?.addresses);
};

export const createAddress = async ({
  label,
  phone,
  address,
  houseNumber,
  apartment,
  deliveryInstructions,
  latitude,
  longitude,
}) => {
  const res = await POST("/addresses", {
    label,
    address,
    latitude: Number(latitude),
    longitude: Number(longitude),
    ...(phone ? { phone: toBdPhone(phone) } : {}),
    ...(houseNumber ? { houseNumber } : {}),
    ...(apartment ? { apartment } : {}),
    ...(deliveryInstructions ? { deliveryInstructions } : {}),
  });
  return normalizeAddress(res?.data?.address);
};

export const updateAddress = async (addressId, payload) => {
  const res = await PATCH(`/addresses/${addressId}`, {
    ...payload,
    ...(payload.phone !== undefined
      ? { phone: payload.phone ? toBdPhone(payload.phone) : null }
      : {}),
  });
  return normalizeAddress(res?.data?.address);
};

export const removeAddress = (addressId) => DELETE(`/addresses/${addressId}`);

export const setDefaultAddress = async (addressId) => {
  const res = await PATCH(`/addresses/${addressId}/default`);
  return normalizeAddress(res?.data?.address);
};
